import { render, staticRenderFns } from "./FiltersComponent.vue?vue&type=template&id=22baa204&scoped=true"
import script from "./FiltersComponent.vue?vue&type=script&lang=js"
export * from "./FiltersComponent.vue?vue&type=script&lang=js"
import style0 from "./FiltersComponent.vue?vue&type=style&index=0&id=22baa204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22baa204",
  null
  
)

export default component.exports